import {
  Box,
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  Typography,
} from "@material-ui/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { columns, UpdateableColumn } from "./csvColumns";

interface Props {
  selectedColumns?: UpdateableColumn[];
  onChange: (selectedColumns: UpdateableColumn[]) => void;
}

export default function SelectColumnsView({
  selectedColumns,
  onChange,
}: Props) {
  const { t } = useTranslation("accounts");

  const [selection, updateSelection] = useState<UpdateableColumn[]>(
    selectedColumns || []
  );

  const handleAttributeChange = (
    column: UpdateableColumn,
    checked: boolean
  ) => {
    const newSelection = checked
      ? [...selection, column]
      : selection.filter(selected => selected !== column);

    updateSelection(newSelection);
  };

  const onContinue = () => {
    onChange(selection);
  };

  return (
    <>
      <DialogContent>
        <Box mt=".5rem" mb=".8rem">
          <Typography gutterBottom variant="body2">
            {t("modal.selectColumn.hint")}
          </Typography>
        </Box>
        <Box p=".5rem 1rem">
          <Box ml="1rem" mt="1rem">
            <Grid container spacing={3}>
              {columns.map(column => {
                const isChecked = selection.includes(
                  column as UpdateableColumn
                );

                return (
                  <Grid item xs={6}>
                    <Box mb="1rem">
                      <FormControlLabel
                        key={column}
                        control={
                          <Checkbox
                            checked={column === "email" ? true : isChecked}
                            onChange={e =>
                              handleAttributeChange(
                                column as UpdateableColumn,
                                e.target.checked
                              )
                            }
                            name={column}
                            color="primary"
                            disabled={column === "email"}
                          />
                        }
                        label={
                          <Box>
                            <Typography variant="body1">
                              {t(`column.${column}`)}
                            </Typography>
                          </Box>
                        }
                      />
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onContinue}
          color="primary"
          variant="contained"
          disableElevation
          disabled={selection.length < 1}
        >
          {t("modal.selectColumn.next")}
        </Button>
      </DialogActions>
    </>
  );
}
